import { render, staticRenderFns } from "./PatientPaymentsView.vue?vue&type=template&id=1d4c0868&scoped=true"
import script from "./PatientPaymentsView.vue?vue&type=script&lang=js"
export * from "./PatientPaymentsView.vue?vue&type=script&lang=js"
import style0 from "./PatientPaymentsView.vue?vue&type=style&index=0&id=1d4c0868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c0868",
  null
  
)

export default component.exports